module.exports = __webpack_public_path__ + "img/ic-mail.e304911e.svg";